module.exports = __webpack_public_path__ + "static/media/family_04.19cb6897.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/family/JPEG/family_04.jpg
// module id = 5836
// module chunks = 0